import View from "../framework/view";
import Server from "../server";
import template from "../../pugc/users";
import jQuery from "jquery";
import {User} from "../bo/user";
import {roles} from "../misc/types";
import {formToJson, pushHash} from "../misc/utils";
import Alerts from "../misc/alerts";


export class UsersView extends View {

    static classname = "users-view";

    private readonly server = Server.instance();

    private users : User[] | undefined;

    private edit_user? : User;

    private new_user = true;

    constructor() {
        super(UsersView.classname);
        this.refresh();
    }

    refresh() {
        const status_ = this.server.getUsers();
        status_.then((users) => {
            this.users = users;
            this.update();
        });
    }

    protected render0(): JQuery<HTMLElement> {

        const data = {
            users: this.users,
            edit_user: this.edit_user,
            new_user: this.new_user,
            roles: roles,
        };

        const out = this.pug(template, data);

        out.find(".with-validation").validate({
            rules: {
                "username": "required",
            }
        })

        return out;
    }

    editUser(user: User | undefined) {
        this.new_user = ! user;
        this.edit_user = user || {};
        this.update();
    }

    saveUser() {
        const form = this.elt().find("form.editor");
        const user : User = {};
        formToJson(form, user);
        const save_ = this.server.saveUser(user);
        // @ts-ignore
        if ((user["password"] || user["password2"]) && (user["password"] != user["password2"])) {
            Alerts.alert("Passswords must match");
            return;
        }

        save_.then((users) => {
            this.users = users;
            this.new_user = false;
            this.edit_user = undefined;
            this.update();
        });
    }

}

View.on(
    "." + UsersView.classname,
    "click",
    ".add-user",
    function(that: UsersView, event, elt) {
        event.preventDefault();
        that.editUser(undefined)
    });

View.on(
    "." + UsersView.classname,
    "click",
    ".edit",
    function(that: UsersView, event, elt) {
        event.preventDefault();
        const user = jQuery(elt).data("user") as User;
        that.editUser(user);
    });

View.on(
    "." + UsersView.classname,
    "click",
    ".save-user",
    function(that: UsersView, event, elt) {
        event.preventDefault();
        that.saveUser();
    });

